var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 79,
  height: 13,
  fill: "none",
  viewBox: "0 0 79 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#43FFD2",
  d: "M76.48 3.541a259.5 259.5 0 0 0-37.15.847 260 260 0 0 0-18.455 2.44c-3.06.522-6.117 1.082-9.17 1.722-1.524.295-3.045.648-4.566.983l-1.87.413-.752.181 1.584.413c1.194.307 2.088.987 2.001 1.525-.087.539-1.126.717-2.32.41l-5.45-1.416-.015-1.925 3.808-.92 1.553-.366 1.15-.253c1.53-.335 3.05-.689 4.59-.984q4.593-.943 9.219-1.724A257 257 0 0 1 39.182 2.44a261 261 0 0 1 37.346-.857c1.222.058 2.196.545 2.175 1.09-.014.544-1.009.937-2.223.878z"
})));
export default SvgUnderline;